import React, { useEffect, useState, } from "react"
import { useNavigate, } from "react-router-dom"
import { useDispatch, useSelector, } from "react-redux"
import { Helmet, } from "react-helmet"
import { login, authorise, } from "../../../redux/actions/authActions"
import { joystickURL } from "../../../constants"
import joystickLogo from "../../../assets/images/joystick-logo.jpg"
import ErrorComponent from "../../layouts/ErrorComponent"
import Loading from "../../layouts/Loading"

import "./LoginComponent.scss"

export default function LoginComponent() {
  const navigate = useNavigate()

  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")

  const dispatch = useDispatch()
  const state = useSelector(state => ({
    auth: state.auth,
  }))

  useEffect(() => {
    dispatch(authorise())
  }, [])

  useEffect(() => {
    if (null !== state.auth.data) {
      window.location.href = "/"
    }
  }, [state.auth])

  const onFormSubmit = (e) => {
    e.preventDefault()

    dispatch(login({ username, password, }))

    setUsername("")
    setPassword("")
  }

  const onUsernameChange = (e) => {
    setUsername(e.target.value)
  }

  const onPasswordChange = (e) => {
    setPassword(e.target.value)
  }

  if (state.auth.loading) {
    return <div className="container login-container text-center">
      <Helmet>
        <title>Sign In - {process.env.REACT_APP_NAME}</title>
      </Helmet>
      <Loading/>
    </div>
  }

  return <div className="container mt-4 mb-5 login-container">
    <Helmet>
      <title>Sign In - {process.env.REACT_APP_NAME}</title>
    </Helmet>
    <div className="col-md-2 offset-md-5">
      <div className="login-joystick-logo-container">
        <img
          src={joystickLogo}
          alt="Joystick Logo"
          className="login-joystick-logo"
        />
      </div>
      <h3 className="login-lead fw-bold mb-0">Sign In</h3>
      <form method="post" onSubmit={onFormSubmit}>
        <ErrorComponent error={state.auth.error} className={"mt-4"}/>
        <div className="form-group">
          <label htmlFor="username">Username</label>
          <input
            autoFocus
            name="username" 
            className="form-control login-username-input"
            id="username"
            value={username}
            onChange={onUsernameChange}
            type="text"
            autoComplete="on"
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            name="password" 
            className="form-control login-password-input"
            id="password"
            value={password}
            onChange={onPasswordChange}
          />
        </div>
        <div className="login-buttons-container mt-3 text-end">
          <a
            href={joystickURL+"/user/register"}
            className="btn joystick-btn"
          >
            Register
          </a>
          <input 
            type="submit" 
            className="btn joystick-success login-submit-button ms-4" 
          />
        </div>
      </form>
    </div>

    <footer className="col-md-4 offset-md-4 py-5 py-lg-5 justify-content-center">
      <p>© Joystick 2026</p>
      <p className="ms-4">
        <a href="/privacy-policy" className="privacy-policy">Privacy Policy</a>
      </p>
    </footer>
  </div>
}
